import { LOCAL__generation_upsert_generation } from '@/state/generation/entity/LOCAL__generation_upsert_generation';
import { store } from '@/state/store';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { FN_IMAGE_ASSET__add_to_generation_single } from './FN_IMAGE_ASSET__add_to_generation_single';

export function FN_IMAGE_ASSET__add_to_generations(images_map: Map<string, DTO__image_asset>) {
  let { generations_map } = store.getState().slice_generation;

  let generations_updated = [];

  for (let generation of generations_map.values()) {
    let is_any_image_initialized = FN_IMAGE_ASSET__add_to_generation_single(generation, images_map);

    if (!is_any_image_initialized) continue;

    generations_updated.push(generation);
  }

  store.dispatch(LOCAL__generation_upsert_generation(generations_updated));
}
